export default __webpack_public_path__ + "static/media/The Ingredients of Consciousness.bc28bcc6.mp3";